'use client';

import { ButtonProps } from './interfaces';

import { SegmentButtonContainer } from './styles';

/**
 * Segment button component used for the shifts page
 */
export const SegmentButton = ({ label, onClick, type = 'button', active = false }: ButtonProps) => {
  return (
    <SegmentButtonContainer onClick={onClick} type={type} $active={active}>
      {label}
    </SegmentButtonContainer>
  );
};
